import React from 'react'
import { checkTranslation, chooseWallpaper, translate } from "../../utils/useful";
import Responsive from '../../components/Responsive';
import CustomLoader from '../../components/CustomLoader';
import StagesManager from '../../components/StagesManager';
import EnterRoom from './EnterRoom';
import History from './History';
import YourRooms from './YourRooms';
import RoomSchedule from './RoomSchedule';
import FormViewer from '../../components/FormViewer';
import AppletFrame from '../../components/header/AppletFrame';
import HttpServices from '../../utils/Http.services';
import moment from 'jalali-moment';
import Modal from '../../components/Modal';
import store from '../../stores/storeConfig';
import { setPage } from '../../stores/actionsList';
import SelectApplet from '../../components/useful/SelectApplet';
import RoomsToolbar from './RoomsToolbar';
import NewSchedule from './NewSchedule';


class RoomsHome extends React.Component {
    state = {
        pages: [
            { key: '', label: '{{lang}}rooms.Enter Room', icon: '/assets/icons/rooms/enter-purple.svg', description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.' },
            { key: 'rooms', label: '{{lang}}rooms.Your Rooms', icon: '/assets/icons/rooms/rooms-purple.svg', description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.' },
            { key: 'schedule', label: '{{lang}}rooms.Schedule', icon: '/assets/icons/rooms/schedule-purple.svg', description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.' },
            { key: 'history', label: '{{lang}}rooms.History', icon: '/assets/icons/rooms/history-purple.svg', description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.' },
        ],
        currentPage: '',
        isLoader: false,

        // headers: [
        //     { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}rooms.Title', placeholder: '{{lang}}rooms.Add title', required: true } },

        //     { key: 'startTime', type: 'DateTimeInput', col: '6', information: { label: '{{lang}}rooms.Start time', placeholder: '{{lang}}rooms.Select start time', required: true }, showMain: false },
        //     { key: 'endTime', type: 'DateTimeInput', col: '6', information: { label: '{{lang}}rooms.End time', placeholder: '{{lang}}rooms.Select end time' }, showMain: false },

        //     // { key: 'Format', type: 'CheckboxInput', col: '2', information: { label: '', required: true }, showMain: false },
        //     // { key: 'Format', type: 'SwitchInput', col: '10', information: { type: "local", items: [{ title: '{{lang}}rooms.Daily', },], label: '', placeholder: '{{lang}}rooms.Does not repeat', required: false } },

        //     // { key: 'Notification', type: 'SelectInput', col: '4', information: { type: "local", items: [{ title: '{{lang}}rooms.Email', },], label: '', placeholder: '{{lang}}rooms.Notification', required: false } },
        //     // { key: 'Notification', type: 'TimeInput', col: '4', information: { label: '', placeholder: '{{lang}}rooms.Does not repeat', required: false } },
        //     // { key: 'Notification', type: 'SelectInput', col: '4', information: { type: "local", items: [{ title: '{{lang}}rooms.hours', }, { title: '{{lang}}rooms.days', }, { title: '{{lang}}rooms.weeks', },], label: '', placeholder: '{{lang}}rooms.minutes', required: false } },

        //     // { key: 'url', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}rooms.URL address', placeholder: '{{lang}}rooms.your title plus the date and some other factore make an URL address', required: true } },

        //     { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}rooms.Description', placeholder: '{{lang}}rooms.you can write a description if you want', required: false } },
        //     { key: 'participants', type: 'GlobalUserMultiInput', col: '12', information: { label: '{{lang}}participants', address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}you can add participants', required: false } },

        // ],
    }

    componentDidMount() {
        // this.scheduleModal.showModal()
        // console.log('didmclll', this.props.setHeader)
        if (this.props.setHeader) {
            this.props.setHeader({
                'toolbar': this.toolbarView,
                'showToolbar': true,
                'showFrames': true,
                'showSettings': true,
                // title: !this.props.isApplet && '{{lang}}Drive',
                type: 'drive'
            })
        }

        this.checkDefaultTab()


    }
    componentDidUpdate(prevProps) {
        if (JSON.stringify(this.props.windowData.path) != JSON.stringify(prevProps.windowData?.path)) {
            // this.changeFrame('enter')
            this.checkDefaultTab()

        }
    }



    checkDefaultTab = () => {

        let path = this.props.windowData.path
        // console.log(this.props.baseUrl)

        // console.log(path)
        let pageKey = path[this.props.baseUrl.length]

        // console.log(pageKey)

        if (pageKey == null) {
            pageKey = ''
        }

        // return
        this.stageManager.changeStage(pageKey)
        this.setState({ currentPage: pageKey }, () => {
            if (this.props.setHeader) {
                this.props.setHeader("dummy", 1)
            }
        })


    }




    changeFrame = (stage) => {
        // console.log('firstitem', item)
        // this.setState({ currentPage: stage }, () => {
        // this.stageManager.changeStage(stage)
        // if (this.props.setHeader) {
        //     this.props.setHeader("dummy", 1)
        // }
        // })

        console.log(stage)
        // return
        this.props.changePage(stage)
    }
    toolbarView = () => {
        return (
            <>
                {/* {this.props.toolbarView && (
                    <>
                        {this.props.toolbarView()}
                    </>
                )} */}
                <RoomsToolbar ref={el => { this.roomsToolbar = el }}
                    colors={this.props.colors}
                    language={this.props.language}
                    changePage={this.props.changePage}
                    changeFrame={this.changeFrame}
                    currentPage={this.state.currentPage}
                    page={this.props.page}
                    width={this.props.width}
                    currentApplet={this.props.currentApplet}
                    setData={this.setData}
                />
            </>
        )
    }

    componentWillUnmount() {
    }


    changePage = (item) => {
        // console.log('changePage*')
        this.stageManager.changeStage(item.key)
        this.setState({ currentPage: item.key })
    }
    
    changesStage = (stage) => {
        this.stageManager.changeStage(stage)
        this.setState({ currentPage: stage })
    }
    showDate = (date, showHour) => {
        let format = 'DD MMM YYYY'
        if (showHour) {
            format = format + ' hh:mm'
        }
        if (date) {
            // console.log('moment(date).format(format)', moment(date).format(format))
            date = moment(date).format(format)
        }
        else {
            date = ''
        }
        return date
    }
    addCalendar = () => {
        console.log('addCalendar', this.state.schedule)
        let schedule = this.state.schedule
        let data = { values: { title: schedule.title, start: schedule.schedule.startTime,end: schedule.schedule.endTime, features: 'Rooms', type: 'normal', description: 'Room Schedule', participants: schedule.participants } }
        HttpServices.request('addUserCalender', data, (fetchResult, fetchError) => {

            console.log(fetchResult, fetchError)
            if (fetchError) {
                return
            }
            store.dispatch(setPage([]))
        })
    }


    functionsHandler = (type, name, data, info) => {

        // console.log(type)
        // console.log(name)

        // if (type) {
        //     if (type == 'admin') {
        //         this[name](data, info)
        //     } else {
        //         if (this[type] && this[type][name]) {
        //             this[type][name](data)
        //         }
        //     }
        // } else {
        if (this[name]) {
            this[name](data, info)
        } else {
            if (this.props.functionsHandler) {
                this.props.functionsHandler(type, name, data, info)
            }
        }
        // }
    }



    render() {
        // console.log('this..changePage', this.props.changePage)

        return (

            <div className=" w-100 h-100 window-content-radius d-flex flex-column " style={{ backgroundColor: '#F5F5F5', }}>
                {/* <div className='p-2 flexc top-0 scroll-no-scrollbar window-content-radius-top' style={{ background: 'linear-gradient(to right,#9564FE, #7064FE)', position: 'sticky', zIndex: 2, height: '60px' }}>
                    <img src="/assets/icons/portals/roomtest.svg" height={50} />
                    <div className='mld-2 flexcb w-100'>
                        <div className='' style={{ justifyContent: 'flex-end' }}>
                            <p className="font-size-20 weight-500" style={{ color: "#fff" }} >{translate('Rooms Portal')}</p>
                            <p className="font-size-12 mb-2" style={{ color: "#fff", lineHeight: '95%' }} >Fast and easy connection</p>
                        </div>
                        <AppletFrame language={this.props.language} width={this.props.width} sections={this.props.sections} modules={this.props.modules} changePage={this.props.changePage} />
                    </div>
                    <SelectApplet type='Rooms' ref={el => this.selectApplet = el} setData={this.props.setData} />
                </div> */}

                <div className='d-flex flex-wrap w-100 flex-1 h-100 ' style={{}}>
                    {/* <Responsive height='100%' styles={{ zIndex: 1, }} width={this.props.width} media={{ xs: "none", sm: '3', md: '4', lg: "3", xl: "3" }}>
                        <div className='h-100 w-100 d-flex scroll-no-scrollbar  flex-column' style={{ backgroundColor: "#fff", position: 'sticky', top: 0, }}>
                            <div className=' ' style={{ borderRight: '1px solid #eee' }}>
                                <div className=' mt-2 w-100'>
                                    {this.state.pages.map((item, index) => {
                                        return (
                                            <div className='w-100' key={index}>
                                                <button onClick={() => this.changePage(item)} className={' pt-2 pb-3 px-3 br-10 mx-2 my-1 ' + (this.state.currentPage == item.key ? '' : 'hover-purple')} style={{ backgroundColor: this.state.currentPage == item.key ? '#f2f6f6' : '' }}>
                                                    <div className='pt-1 flexc'>
                                                        <img className='mrd-3' src={item.icon} height={30} style={{}} />
                                                        <p className='text-start font-size-15 weight-500' style={{ color: "#333" }}>{checkTranslation(item.label)}</p>
                                                    </div>
                                                    <div>
                                                        <p className='text-start font-size-10' style={{ color: "#777" }}>{checkTranslation(item.description)}</p>
                                                    </div>
                                                </button>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </Responsive> */}


                    {/* <Responsive styles={{ zIndex: 1 }} width={this.props.width} height="100%" media={{ xs: "12", sm: '12', md: '12', lg: "12", xl: "12" }}> */}

                    <div className=' w-100 h-100 d-flex  window-content-radius' style={{ backgroundColor: '#f6f6f6' }}>
                        <StagesManager ref={el => this.stageManager = el} className={'flex-1'} fast={true}>
                            <EnterRoom showDate={this.showDate} page={this.props.page} width={this.props.width} language={this.props.language} isLoading={this.props.isLoading} createRoom={this.props.createRoom} stage={0} stageName={''} changesPage={this.changePage} changePage={this.props.changePage} joinRoomByLink={this.props.joinRoomByLink} scope={this.props.scope} functionsHandler={this.functionsHandler} />
                            <RoomSchedule page={this.props.page} applet={this.props.applet} showDate={this.showDate} width={this.props.width} language={this.props.language} isLoading={this.props.isLoading} createRoom={this.props.createRoom} stage={1} stageName={'schedule'} changesPage={this.changePage} changePage={this.props.changePage} scope={this.props.scope} functionsHandler={this.functionsHandler} />
                            <History page={this.props.page} applet={this.props.applet} showDate={this.showDate} width={this.props.width} language={this.props.language} isLoading={this.props.isLoading} createRoom={this.props.createRoom} stage={1} stageName={'history'} scope={this.props.scope} functionsHandler={this.functionsHandler} />
                            <YourRooms page={this.props.page} applet={this.props.applet} showDate={this.showDate} width={this.props.width} language={this.props.language} isLoading={this.props.isLoading} createRoom={this.props.createRoom} stage={1} stageName={'rooms'} scope={this.props.scope} functionsHandler={this.functionsHandler} />
                            <NewSchedule page={this.props.page} applet={this.props.applet} showDate={this.showDate} width={this.props.width} language={this.props.language} isLoading={this.props.isLoading} createRoom={this.props.createRoom} stage={1} stageName={'newschedule'} scope={this.props.scope} changePage={this.props.changePage} functionsHandler={this.functionsHandler} />

                            {/* <div className='window-content-radius scroll-no-scrollbar h-100' stage={1} stageName={'newschedule'}>
                                <div className='flexcb w-100 py-2 px-3' style={{ position: 'sticky', top: 0, backgroundColor: '#f5f5f5', zIndex: 10 }}>
                                    <button className='flexcc' onClick={() => { this.stageManager.lastStage() }}>
                                        <img src='/assets/icons/rooms/cancel.svg' width={16} />
                                    </button>
                                    <button className=' br-30 flexcc py-2 px-4' style={{ background: 'linear-gradient(to right,#9564FE, #7064FE)', color: '#fff', transition: 'all 0.5s' }} onClick={() => { this.saveSchedular() }}>
                                        <p className='' style={{ whiteSpace: 'nowrap' }}>{translate("rooms.Save")}</p>
                                    </button>
                                </div>
                                <div className='h-100 px-1 py-2'>
                                    <FormViewer ref={el => this.form = el} headers={this.state.headers} theme={"bordered-form"} inputClass={"bordered-input"} />
                                </div>
                            </div> */}
                        </StagesManager>
                    </div>
                    {/* </Responsive> */}
                </div>
                <Modal className="" ref={el => this.scheduleModal = el} maxWidth={400} style={{}}>


                </Modal>

            </div>

        )
    }
}

export default RoomsHome;